import { useEffect, useRef } from 'react';

/**
 * Custom hook to lock/unlock body scroll
 * Uses a reference counter to handle multiple locks properly
 * @param {boolean} isLocked - Whether to lock the scroll
 */

// Global lock counter to handle multiple simultaneous locks
let lockCount = 0;

export const useScrollLock = (isLocked) => {
  const wasLocked = useRef(false);

  useEffect(() => {
    const currentlyLocked = Boolean(isLocked);
    const previouslyLocked = wasLocked.current;

    if (currentlyLocked && !previouslyLocked) {
      // Transitioning from unlocked to locked
      lockCount++;
      document.body.style.overflow = 'hidden';
      wasLocked.current = true;
    } else if (!currentlyLocked && previouslyLocked) {
      // Transitioning from locked to unlocked
      lockCount--;
      if (lockCount <= 0) {
        lockCount = 0; // Safety: prevent negative counts
        document.body.style.overflow = '';
      }
      wasLocked.current = false;
    }

    // Cleanup: decrement if we were locked
    return () => {
      if (wasLocked.current) {
        lockCount--;
        if (lockCount <= 0) {
          lockCount = 0;
          document.body.style.overflow = '';
        }
        wasLocked.current = false;
      }
    };
  }, [isLocked]);
};
